import React from "react";
import { Box } from "@mui/material";
import { DndContext, KeyboardSensor, PointerSensor, closestCenter, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext, sortableKeyboardCoordinates, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

// A vertical list reordered by drag. Each list is its own context, so an item never leaves its list.
export const SortableList = ({ ids, onReorder, disabled = false, children }) => {
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 4 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }),
  );
  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={({ active, over }) => {
        if (!over || active.id === over.id) return;
        onReorder(ids.indexOf(active.id), ids.indexOf(over.id));
      }}
    >
      <SortableContext items={ids} strategy={verticalListSortingStrategy} disabled={disabled}>
        {children}
      </SortableContext>
    </DndContext>
  );
};

// One row: `children({ handleProps, isDragging })` renders the row and puts handleProps on its grip.
export const SortableRow = ({ id, children }) => {
  const { setNodeRef, setActivatorNodeRef, listeners, attributes, transform, transition, isDragging } = useSortable({ id });
  return (
    <Box
      ref={setNodeRef}
      sx={{ position: "relative", zIndex: isDragging ? 2 : "auto" }}
      style={{ transform: CSS.Translate.toString(transform), transition }}
    >
      {children({ handleProps: { ref: setActivatorNodeRef, ...attributes, ...listeners }, isDragging })}
    </Box>
  );
};
